'use client';

import { motion, AnimatePresence } from 'motion/react';
import { Phone, ArrowUp } from 'lucide-react';
import { useState, useEffect } from 'react';
import Image from 'next/image';
import { ContactFormModal } from './ContactFormModal';

export function StickyButtons() {
  const [showModal, setShowModal] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const whatsappNumber = '+971588980456'; // Change to your WhatsApp number
  const whatsappMessage = 'Hi, I am interested in Gate Eleven Residences';

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsApp = () => {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(url, '_blank');
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Back to Top Button - Above WhatsApp */}
      <AnimatePresence>
        {showBackToTop && (
          <motion.button
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={scrollToTop}
            className="fixed bottom-4 right-4 lg:bottom-8 lg:right-8 z-40 bg-[#c19964] text-white p-4 rounded-full shadow-2xl hover:bg-[#a88555] transition-colors"
            aria-label="Back to Top"
          >
            <ArrowUp className="w-4 h-4 md:w-7 md:h-7" />
          </motion.button>
        )}
      </AnimatePresence>


      {/* Contact Us Button - Desktop Only (Left Side) */}
      <motion.button
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 1.2 }}
        whileHover={{ x: 5 }}
        onClick={() => setShowModal(true)}
        className="hidden lg:block fixed left-0 top-1/2 -translate-y-1/2 z-40 bg-[#c19964]/80 text-white px-6 py-4 shadow-2xl hover:bg-[#a88555] transition-all group origin-left"
        style={{ writingMode: 'vertical-rl', transform: 'translateY(-50%) rotate(180deg)' }}
        aria-label="Contact Us"
      >
        <div className="flex items-center gap-2">
          <Phone className="w-5 h-5" />
          <span className="text-sm tracking-[0.2em] font-medium rotate-180">CONTACT US</span>
        </div>
      </motion.button>

      {/* Contact Form Modal */}
      <ContactFormModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}
